import React from 'react';

function SystemMetrics() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">System Metrics</h1>
        <p className="text-gray-600 mt-2">
          Monitor system performance and usage metrics
        </p>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <p className="text-gray-600">System metrics component coming soon...</p>
      </div>
    </div>
  );
}

export default SystemMetrics;